import ReactGA from 'react-ga4';

// Get Google Analytics Measurement ID from environment variables
const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Initialize Google Analytics
export const initGA = () => {
  if (MEASUREMENT_ID && MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.initialize(MEASUREMENT_ID, {
      debug: process.env.NODE_ENV === 'development',
    });
    console.log('Google Analytics initialized with ID:', MEASUREMENT_ID);
  } else {
    console.warn('Google Analytics not initialized: Missing or invalid MEASUREMENT_ID');
  }
};

// Track page views
export const trackPageView = (path) => {
  if (MEASUREMENT_ID && MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

// Track custom events
export const trackEvent = (action, category = 'General', label = '', value = 0) => {
  if (MEASUREMENT_ID && MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.event({
      action,
      category,
      label,
      value,
    });
  }
};

// Track conversion events (useful for your converters)
export const trackConversion = (conversionType, fromUnit, toUnit, value) => {
  if (MEASUREMENT_ID && MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.event({
      action: 'conversion',
      category: 'Unit Conversion',
      label: `${conversionType}: ${fromUnit} to ${toUnit}`,
      value: parseFloat(value) || 0,
      custom_parameters: {
        conversion_type: conversionType,
        from_unit: fromUnit,
        to_unit: toUnit,
        conversion_value: value,
      },
    });
  }
};

// Track button clicks
export const trackButtonClick = (buttonName, category = 'UI') => {
  if (MEASUREMENT_ID && MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.event({
      action: 'click',
      category,
      label: buttonName,
    });
  }
};
